import React from 'react';
import FrigoPlusFlexy from "../../../assets/images/Frigo-Plus-Flexy.png";
import heatexchanger from "../../../assets/images/heatexchanger.png";
import Steamgenerator from "../../../assets/images/Steamgenerator.png";

import { useTranslation } from 'react-i18next';

function CoolingUnit() {
  const { t } = useTranslation();
  const products = [
    {
      name: <h1>{t('Cooler & Heater')}</h1>,
      description: <h2>{t('Temperature control is a vital challenge when it comes to winemaking. A vast variety of choice in our coolers and heaters will make storing, fermentation and other necessary processes easier and therefore guarantee the quality.')}</h2>,
      img: FrigoPlusFlexy, 
    },
    
    {
      name: <h1>{t('Heat Exchanger')}</h1>,
      description: <h2>{t('Tube-in-tube heat exchange (also known as double tube heat exchanger) consists of a heat exchanger with two concentric tubes. The product flows through the inner tube while the service does it through the space between the two tubes.')}</h2>,
      img: heatexchanger,
    },
    {
      name: <h1>{t('Steam Generator')}</h1>,
      description: <h2>{t('Tecnovap still is at the forefront of innovation in the steam cleaning sector, working together with national and multinational companies allowing to clean your machinery, tanks, and barrels with high temperature and pressure.')}</h2>,
      img: Steamgenerator,
    },
  ];

  return (
    <div className="main-infocontainer">
      {products.map((product, index) => (
        <div className="item-container" key={index}>
          <img src={product.img} alt={product.name} />
          <div className="text-info">
            {product.name}
            {product.description}
          </div>
        </div>
      ))}
    </div>
  );
}

export default CoolingUnit;
